const defaultTagData = {
  shareTitle: 'SBS 이벤트 : 매일 선물이 팡팡!',
  shareDescription: 'SBS에서만 즐기는 특별한 이벤트!',
  shareImageUrl: 'https://img2.sbs.co.kr/sns/section_main/event.png',
  currentUrl: 'https://www.sbs.co.kr/event',
  keywords: 'SBS,에스비에스,뉸,sbs온에어,sbs실시간,www.sbs.co.kr,sbs.co.kr,지상파,VOD 무료,SBS 드라마 무료,sbskorea,sbstv,sbs편성표,sbs 韓国,sbs korean,서울방송,Seoul Broadcasting System'
};

export default { ...defaultTagData };
